<template>
  <div class="hover:bg-gray-300 hover:border-gray-600">
    <div @click="toggle" class="flex items-center cursor-pointer">
      <div class="form-control">
      <svg v-if="myValue" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="toggle-on"
           class="fill-current w-4 h-4 mr-2" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
        <path fill="currentColor"
              d="M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"></path>
      </svg>
      <svg v-if="!myValue" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="toggle-off"
           class="fill-current w-4 h-4 mr-2" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
        <path fill="currentColor"
              d="M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"></path>
      </svg>
      </div>
      <div class="form-label">
        <span v-if="label && label.length>0">{{ label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "switch-on-off",
  props: ['value', 'label'],
  computed: {
    myValue() {
      return this.value;
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
    }
  }
}
</script>

<style scoped>

</style>